import clsx from 'clsx';
import React from 'react';

import type { BaseRowType, BaseTableProps } from '../helpers';
import { FillSpaceWithDots } from '../../FillSpaceWithDots';
import { gridClasses } from '../helpers';

export const Header = <T extends BaseRowType>({
  schema,
  textSize,
  dottedHeader,
  stickyHeader = false,
}: Pick<BaseTableProps<T>, 'schema' | 'textSize' | 'dottedHeader'> & {
  stickyHeader?: boolean;
}) => (
  <div
    className={clsx(
      gridClasses(textSize),
      stickyHeader && 'sticky top-0 border-b-[0.5px] border-0 border-main-300'
    )}
    role="row"
  >
    {schema.map(({ justify, colspan, title }) => (
      <div
        key={title}
        // These aren't on text engine yet
        className={clsx(
          justify === 'right' ? 'text-right' : 'text-left',
          colspan,
          justify === 'right' ? '-ml-f2' : ''
        )}
      >
        <div
          className={`text-main-500 ${
            textSize === 'sm' ? 'h-f3' : 'h-f2'
          } flex flex-row`}
          role="columnheader"
        >
          {justify === 'right' && dottedHeader && (
            <FillSpaceWithDots
              marginClassName={
                textSize === 'md' ? 'mb-[7px]' : 'mb-[13px] mr-[4px] ml-f2'
              }
            />
          )}
          <span
            className={clsx([
              'flex flex-shrink-0',
              justify === 'right' && 'ml-auto',
            ])}
          >
            {title}
          </span>
          {justify !== 'right' && dottedHeader && (
            <FillSpaceWithDots
              marginClassName={
                textSize === 'md' ? 'mb-[7px]' : 'mb-[13px] -mr-f2'
              }
            />
          )}
        </div>
      </div>
    ))}
  </div>
);
